// ObjectivesForm.jsx
import React from 'react';
import Input from '../../ui/inputs/Input';
import DateInput from '../../ui/inputs/DateInput';
import CurrencyInput from '../../ui/inputs/CurrencyInput';
import DeleteIconButton from '../../ui/buttons/DeleteIconButton';

const ObjectiveForm = ({ index, objective, onChange, onRemove, canWrite = true }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(index, { ...objective, [name]: value });
  };

  return (
    <div className="grid grid-cols-12 gap-8 items-center">
      <div className="col-span-12 md:col-span-4">
        <Input name="title" label="O quê?" value={objective.title || ''} onChange={handleChange} disabled={!canWrite} />
      </div>
      <div className="col-span-12 md:col-span-4">
        <DateInput
          name="desired_date"
          label="Quando?"
          value={objective.desiredDate || ''}
          onChange={handleChange}
          disabled={!canWrite}
        />
      </div>
      <div className="col-span-12 md:col-span-3">
        <CurrencyInput
          name="total_value"
          label="Quanto?"
          value={objective.totalValue ?? ''} // cuidado com null/undefined
          onChange={handleChange}
          disabled={!canWrite}
        />
      </div>
      {canWrite && (
        <div className="col-span-12 md:col-span-1 flex justify-center items-end h-full">
          <DeleteIconButton onClick={() => onRemove(index)} />
        </div>
      )}
    </div>
  );
};

export default ObjectiveForm;
